import { AccountForm } from "../../components/pages/settings/account/Form";
import { SideMenu } from "../../components/pages/settings/sideMenu";

export const AccountSetting = () => {
  return (
    <div className="flex max-w-[1080px] mx-auto pt-8 px-4">
      <SideMenu />
      <AccountForm />
    </div>
  );
};
